import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_PageHeaderActionItem = _resolveComponent("PageHeaderActionItem")!
  const _component_PageHeaderActions = _resolveComponent("PageHeaderActions")!
  const _component_DanhMucToaXeTable = _resolveComponent("DanhMucToaXeTable")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_PageContentBase = _resolveComponent("PageContentBase")!

  return (_openBlock(), _createBlock(_component_PageContentBase, null, {
    default: _withCtx(() => [
      _createVNode(_component_PageHeaderActions, null, {
        default: _withCtx(() => [
          _createVNode(_component_PageHeaderActionItem, { onClick: _ctx.openPrintViewer }, {
            icon: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, { icon: _ctx.faPrint }, null, 8, ["icon"])
            ]),
            default: _withCtx(() => [
              _createTextVNode(" Xem danh sách nhóm toa xe (PDF) ")
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      }),
      _createVNode(_component_DanhMucToaXeTable, {
        "cur-page": _ctx.currentPage,
        items: _ctx.danhMucToaXeItems,
        "is-loading": _ctx.loading,
        "per-page": _ctx.perPage,
        onDeleteDanhMucToaXeSuccess: _ctx.fetchData
      }, null, 8, ["cur-page", "items", "is-loading", "per-page", "onDeleteDanhMucToaXeSuccess"]),
      (_ctx.danhMucToaXeItems.length > 0)
        ? (_openBlock(), _createBlock(_component_Pagination, {
            key: 0,
            page: _ctx.currentPage,
            "page-size": _ctx.perPage,
            total: _ctx.totalItems,
            onChangePage: _cache[0] || (_cache[0] = (value) => (_ctx.currentPage = value)),
            onChangePageSize: _cache[1] || (_cache[1] = (value) => (_ctx.perPage = value))
          }, null, 8, ["page", "page-size", "total"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}